export default __webpack_public_path__ + "static/media/undraw_folder_39kl.62e7dcef.svg";